import React from 'react'
import blogData from '../../Database/blogData.json';
import Error from '../../Pages/ErrorPage'

// React Router Dom Link
import { Link } from "react-router-dom";



function BlogPost({ id }) {
  // Find the blog post that matches the id
  const post = blogData.find((item) => item.id === id);

  if (!post) {
    return <><Error /></>;
  }
  // Split the content into paragraphs using '\n' as the delimiter
  const paragraphs = post.fullContent.split('\n');

  return (
    <>
      <section
        className="myblog section"
        id="myblog"
        aria-label="myblog"
        style={{ minHeight: "100vh" }}
      >
        <div className="container" style={{ marginTop: "30px" }}>
          <div className="card blog-card">
            <h2
              className="headline headline-2 section-title"
              style={{ fontSize: "4.5rem" }}
            >
              <span className="span">{post.title}</span>
            </h2>
            <div className="slider-list">
              <div className="slider-item">
                <Link to="/" className="slider-card">
                  <figure
                    className="slider-banner img-holder"
                    style={{ '--width': 507, '--height': 618 }}
                  >
                    <img
                      src={post.image}
                      width={507}
                      height={618}
                      loading="lazy"
                      alt="Sport"
                      className="img-cover"
                    />
                  </figure>
                  <div className="slider-content">
                    <span className="slider-title">{post.photoTitle}</span>
                    <p className="slider-subtitle">
                      {post.photoSubtitle}
                    </p>
                  </div>
                </Link>
              </div>
              <div className="section-text">
                {paragraphs.map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default BlogPost;